import { useChain } from '@/hooks/useChains'
import { type ReactElement } from 'react'
import { useAddressBookItem } from '@/hooks/useAllAddressBooks'
import useChainId from '@/hooks/useChainId'
import { getBlockExplorerLink } from '@safe-global/utils/utils/chains'
import SrcEthHashInfo, { type EthHashInfoProps } from './SrcEthHashInfo'

const EthHashInfo = ({
  showName = true,
  avatarSize = 40,
  ...props
}: EthHashInfoProps & { showName?: boolean }): ReactElement => {
  const currentChainId = useChainId()
  const chain = useChain(props.chainId || currentChainId)
  const addressBookItem = useAddressBookItem(props.address, chain?.chainId)
  const link = chain && props.hasExplorer ? getBlockExplorerLink(chain, props.address) : undefined
  const name = showName ? addressBookItem?.name || props.name : undefined

  return (
    <SrcEthHashInfo
      prefix={chain?.shortName}
      {...props}
      name={name}
      addressBookNameSource={props.addressBookNameSource || addressBookItem?.source}
      customAvatar={props.customAvatar}
      ExplorerButtonProps={{ title: link?.title || '', href: link?.href || '' }}
      avatarSize={avatarSize}
      badgeTooltip={props.badgeTooltip}
    >
      {props.children}
    </SrcEthHashInfo>
  )
}

export default EthHashInfo
